import React, { useState, useRef, useEffect, } from 'react';
import { Button, Card, message, Spin } from 'antd';
import "../../assets/styles/bot2.scss";
import ChatAnimationImage from "../../assets/images/icons/chat_circle.gif"
import UserIcon from "../../assets/images/27470347_7309691 1.svg";
import BotIcon from "../../assets/images/1100838311-preview 1.svg";
import { generateAnswer } from '../../apis/ProcessGuruAPI';
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined';
import { useDispatch } from 'react-redux';
import Scrollbar from "perfect-scrollbar";
import { v4 as uuidv4 } from 'uuid';
import HandAnimatedIcon from "../../assets/images/icons/animated_hand.gif"
import "perfect-scrollbar/css/perfect-scrollbar.css";
import ReactQuill from 'react-quill';
import PDFViewer from '../../components/PDFViewer';
import { getPdf } from '../../apis/ProcessGuruAPI';


const Chat = ({ prompt, selectedFile, folderList, showTour, handleInputFocus }) => {
  const dispatch = useDispatch();
  const [userInput, setUserInput] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [isWaiting, setIsWaiting] = useState(false);
  const chatContentRef = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdfData, setPDFDate] = useState({ blob: "", page: 0 });
  const [pdfLoading, setPDFLoading] = useState(false);
  const [selectedPDF, setSelectedPDF] = useState('');

  const [totalFileCount, setTotalFileCount] = useState(0);
  const quillRef = useRef(null);

  useEffect(() => {
    let ps = new Scrollbar(chatContentRef.current);
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    }
  }, []);

  useEffect(() => {
    let totalCount = 0;
    folderList.forEach(item => {
      totalCount += item.file.length;
    })
    setTotalFileCount(totalCount);
  }, [folderList])

  useEffect(() => {
    setUserInput(prompt);
  }, [prompt])

  const handleChatSubmit = async (selectedMessage) => {
    // if (!selectedFile || selectedFile.length === 0) {
    //   message.error("Please select a file");
    //   return;
    // } else
    {
      const strippedText = new DOMParser().parseFromString(selectedMessage, 'text/html').body.textContent; //parse the userInput
      if (!strippedText) {
        message.error("Invalid selected message");
        return;
      }
      setIsWaiting(true);
      setUserInput('')
      let uuid = uuidv4();
      let queryData = {
        type: 'user',
        uuid: uuid,
        query: strippedText,
        response: null,
        meta: [],
        isLoading: true,
        content: strippedText,
        responseType: "success"
      };
      setChatHistory((prevMessages) => [
        ...prevMessages,
        queryData
      ]);
      scollChatToBottom();
      const requestBody = {
        // file_id: selectedFile,
        max_token: 500,
        query: strippedText,
        query_id: uuid,
      };

      try {
        const response = await dispatch(generateAnswer(requestBody));
        if (response.error) {
          let query_id = response.meta.arg.query_id;
          setChatHistory((previousHistory) => {
            let updatedHistory = previousHistory;
            const targetIndex = updatedHistory.findIndex(item => item.uuid === query_id);
            updatedHistory[targetIndex].response = { answer: "Something went wrong!" };
            updatedHistory[targetIndex].meta = [];
            updatedHistory[targetIndex].isLoading = false;
            updatedHistory[targetIndex].responseType = "error";
            return [...updatedHistory];
          })
        } else {
          // Success chat response from server
          setChatHistory((previousHistory) => {
            let updatedHistory = previousHistory;
            const targetIndex = updatedHistory.findIndex(item => item.uuid === response.meta.arg.query_id);
            updatedHistory[targetIndex].response = response.payload.data;
            updatedHistory[targetIndex].meta = response.payload.data.meta.map(item => ({ fileId: item.file_id, name: getFileName(item.file_id), page: item.page }))
            updatedHistory[targetIndex].isLoading = false;
            updatedHistory[targetIndex].responseType = "success";
            return [...updatedHistory];
          })
        }
      } catch (error) {
      } finally {
        setIsWaiting(false);
        scollChatToBottom()
      }
    }
  };

  const scollChatToBottom = () => {
    setTimeout(() => {
      if (chatContentRef.current) {
        chatContentRef.current.scrollTo({
          top: chatContentRef.current.scrollHeight,
          behaviour: "smooth"
        })
      }
    }, 500)
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (!event.shiftKey) {
        // If Shift + Enter is pressed, insert a newline
        // if (!selectedFile || selectedFile.length === 0) {
        //   event.preventDefault();
        // }
        {
          handleChatSubmit(userInput);
        }
      } else {
        // Prevent default behavior to avoid Quill's default newline behavior
        event.preventDefault();
      }
    }
  };

  const downloadPDF = async (name, fileId, page) => {
    console.log('page',page)
    setSelectedPDF(fileId);
    const folder = folderList.find(item => item.file.find(file => file.id === fileId))
    const file = folder.file.find(item => item.id === fileId);

    const data = {
      folderName: folder.folder_name,
      fileName: file.name,
    }
    setPDFLoading(true);
    const response = await dispatch(getPdf(data));

    if (!response.error) {

      const binaryString = window.atob(response.payload.data);

      // Convert the binary string to a TypedArray
      const binary = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        binary[i] = binaryString.charCodeAt(i);
      }

      // Create a Blob from the TypedArray
      const blob = new Blob([binary], { type: 'application/pdf' });

      if (blob) {
        setPDFLoading(false);
        setPDFDate({ name, blob, page })
        setIsModalOpen(true);
      }
      
    } else {
      setPDFLoading(false);
    }
  }

  const getFileName = (fileId) => {
    const file = folderList?.find(item => item.file.find(file => file.id === fileId)).file.find(item => item.id === fileId);
    return file.name;
  }


  return (
    <Card className="chatbot-card" size="large" style={{ border: 0 }}>
      <PDFViewer pdfData={pdfData} show={isModalOpen} handleClose={() => setIsModalOpen(false)} />
      <>
        {chatHistory.length === 0 ? (
          <div className="chatbot-content" ref={chatContentRef} style={{ justifyContent: "center" }}>
            <img className='animation' src={ChatAnimationImage} alt="waiting-gif" width={100} height={100} />
            <p className='text5'>
              I am waiting for a prompt
            </p>
          </div>
        ) :

          <div className="chatbot-content" ref={chatContentRef}>
            {
              chatHistory.length > 0 ? chatHistory.map((item, index) => (
                <div key={index} style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                  <div className={`chat-message user`}>
                    <span className='user-message success'>{item.query}</span>
                    <img className='user-icon' src={UserIcon} alt="user-icon" width={40} height={40} />
                  </div>
                  <div className={`chat-message bot`}>
                    <img className='bot-icon' src={BotIcon} alt="bot-icon" width={40} height={40} />
                    {item.isLoading ? <Spin size="small" style={{ marginLeft: 8 }} /> :
                      <div className={`bot-message ${item.responseType}`}>
                        <div style={{ whiteSpace: "pre-line" }}>
                          {item.response.answer}
                        </div>
                        {item.response.meta &&
                          <>
                            {item.meta.length > 0 && <div style={{ color: "gray", fontSize: "12px", borderTop: "1px solid gray", paddingTop: "4px", marginTop: "4px" }}>
                              Reference:
                            </div>}

                            <div style={{ display: "flex", flexDirection: "column", gap: "7px", maxHeight: "45px", overflowY: "auto", paddingTop: "0px" }}>
                              {
                                item.meta.map((file, index) => (
                                  <div key={index} style={{ display: "flex", gap: "5px", fontSize: "12px", color: "black", display: "flex", gap: 2 }}>
                                    <div style={{ display: "flex", alignItems: "flex-start", gap: "5px", cursor: "pointer" }} onClick={() => downloadPDF(file.name, file.fileId, 0)}>
                                      <FilePdfOutlined style={{marginTop: "2px"}} />{file.name}</div>
                                    {file.page.length > 0 && <div>
                                      - ( {
                                        file.page.map((page, index) => (<span onClick={() => downloadPDF(file.name, file.fileId, page)} style={{ color: "#4b8bf2", cursor: "pointer" }}>Page no: {page}{index !== file.page.length-1 && ","}  </span>))
                                      } )
                                    </div>}
                                    {(selectedPDF == file.fileId) && pdfLoading && <span>Loading...</span>}
                                  </div>
                                ))
                              }
                            </div>

                          </>
                        }
                      </div>}
                  </div>
                </div>
              ))
                : null
            }

          </div>
        }
      </>

      <div className="chat-input" style={{ flexDirection: "column" }}>
        <div className='chat-input-content'>
          <div className='chat-input-field'>

            <ReactQuill
              placeholder="Type your prompt..."
              ref={quillRef}
              className="quill-prompt"
              theme="bubble"
              modules={{ toolbar: false }}
              value={userInput}
              onChange={(e) => setUserInput(e)}
              onKeyDown={handleKeyPress}
            />
          </div>

          <Button
            className="chat-input-button"
            type="primary"
            onClick={() => handleChatSubmit(userInput)}
            disabled={isWaiting || userInput.length == 0 || userInput === "<p><br></p>"}
          >
            Submit
          </Button>
        </div>
        <div style={{ textAlign: "center", width: "100", fontSize: "12px", paddingRight: "50px", marginTop: "3px" }}>
          Process Buddy is prone to factual inaccuracies; It is advisable to verify the information.
        </div>
        {showTour && <div className="hand-animated" style={{ position: "absolute", zIndex: "10000", bottom: "-20px" }}>
          <img src={HandAnimatedIcon} width={80} />
        </div>}
      </div>

    </Card>
  );
};

export default Chat;
